
import NetworkManagerMixin, {
  throwsNetworkError,
} from "@/utils/http/NetworkManagerMixin";
import JackocoinsNetworkManagerMixin from "@/mixins/JackocoinsNetworkMangerMixin";
import { EServices, IVForm } from "@/types";
import { requiredRule } from "@/utils/rules";
import ComplaintsClient from "../services/ComplaintsClient";

import {
  Component,
  Inject,
  Mixins,
  Prop,
  Ref,
  Watch,
  Emit,
} from "vue-property-decorator";

@Component({})
export default class MakeComplaintDialog extends Mixins(
  JackocoinsNetworkManagerMixin
) {
  @Prop(Boolean)
  showDialog!: boolean;

  @Emit("close-dialog")
  closeDialog() {}

  @Ref()
  complaintForm!: IVForm;

  requiredRule = requiredRule;

  @Inject(EServices.complaint)
  complaintsClient!: ComplaintsClient;

  transactionId!: string;
  blockchainTransactionHash!: string;
  description!: string;
  additionalDetails!: string;

  @throwsNetworkError()
  async submitComplaint() {
    if (!this.complaintForm.validate()) return;

    const response = await this.complaintsClient.createComplaints(
      this.transactionId,
      this.blockchainTransactionHash,
      this.description,
      this.additionalDetails
    );

    if (response.status === 201) {
      this.$emit("close-dialog");
      this.complaintForm.reset();

      toast({
        message: "Ticket submitted",
        icon: "mdi-check",
        iconColor: "green",
      });
    }
    return response;
  }

  @Watch("error.submitComplaint")
  onError(message: string) {
    if (message)
      toast({ icon: "mdi-exclamation-thick", iconColor: "red", message });
  }
}
